import '../base/pageTheme.esm.js';
import { palettes } from '../base/palettes.esm.js';
import { createUnifiedTheme } from './UnifiedTheme.esm.js';

const themes = {
  light: createUnifiedTheme({ palette: palettes.light }),
  dark: createUnifiedTheme({ palette: palettes.dark })
};

export { themes };
//# sourceMappingURL=themes.esm.js.map
